/* import axios from 'axios' */
import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_URL}${process.env.VUE_APP_API_PATH}/administracao`

export default {
    obterEstatisticasPagamentosMensais(ano) {
        return axiosJwt
            .get(`${api}/relatorios/pagamentosmensais?ano=${ano}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
    obterRelatorioPagMenAprovReprov(filtro) {
        return axiosJwt
            .get(`${api}/relatorios/pagamentosmensaismodulos?ano=${filtro.anoCorrente}&mes=${filtro.mesCorrente}&modulo=${filtro.modulo}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterAnosPainel() {
        return axiosJwt
            .get(`${api}/relatorios/anospagamentosmenais`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },
}
